export default "__VITE_ASSET__27027b0c__"